import service from "@/store/services/tasks-service";

const state = {
  list: [],
  task: {},
  meta: { page: { total: 0 } },
  url: null
};

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, task) => {
    state.task = task;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  }
};

const actions = {
  list({ commit }, params) {
    return service.list(params).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit }, params) {
    return service.get(params).then(task => {
      commit("SET_RESOURCE", task);
    });
  },

  add({ commit }, params) {
    return service.add(params).then(task => {
      commit("SET_RESOURCE", task);
    });
  },

  update({ commit }, params) {
    return service.update(params).then(task => {
      commit("SET_RESOURCE", task);
    });
  },

  destroy(methods, params) {
    return service.destroy(params);
  }
};

const getters = {
  list: state => state.list,
  listTotal: state => (state.meta ? state.meta.page.total : 0),
  task: state => state.task,
  url: state => state.url
};

const tasks = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default tasks;
